module.exports = __webpack_public_path__ + "img/icon-add-patient-dark.fe14bb29.svg";